import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { Menu } from 'features/MenuList/models/menu';
import { CommonResponse } from 'models';

// state class
export interface MenuDetailState {
  loading: boolean;
  menu: Menu;
}

// init model state
const initialState: MenuDetailState = {
  loading: false,
  menu: {} as Menu,
};

// slice inventory
const menuDetailSlice = createSlice({
  name: 'menuDetailReducer',
  initialState,
  reducers: {
    fetchMenu(state, action: PayloadAction<{ menu_id: number; expired_date: Date }>) {
      state.loading = true;
    },
    fetchMenuSuccess(state, action: PayloadAction<CommonResponse<Menu>>) {
      state.loading = false;
      state.menu = action.payload.data;
    },
    fetchMenuFailed(state) {
      state.loading = false;
    },
    patchMenu(state, action: PayloadAction<Menu>) {
      state.loading = true;
    },
    patchMenuSuccess(state) {
      state.loading = false;
    },
    patchMenuFailed(state) {
      state.loading = false;
    },
    patchSubMenu(state, action: PayloadAction<Menu>) {
      state.loading = true;
    },
    patchSubMenuSuccess(state) {
      state.loading = false;
    },
    patchSubMenuFailed(state) {
      state.loading = false;
    },
    removeStateMenu: (state, action) => {
      state.menu = action.payload;
    },
  },
});

// Actions
export const menuDetailActions = menuDetailSlice.actions;

// Selectors
//export const selectUpdateMenu = (state: RootState) => state.menuDetailReducer.common_res;
export const selectMenu = (state: RootState) => state.menuDetailReducer.menu;

// Reducer
export const menuDetailReducer = menuDetailSlice.reducer;
